export const RATING_COLORS = {
  high: '#22c55e',
  medium: '#eab308',
  low: '#ef4444',
  na: '#9ca3af',
};

export const LEVEL_LABEL_KEYS = {
  high: 'INBOX_MGMT.QUALITY.CHART.LEVEL_HIGH',
  medium: 'INBOX_MGMT.QUALITY.CHART.LEVEL_MEDIUM',
  low: 'INBOX_MGMT.QUALITY.CHART.LEVEL_LOW',
  na: 'INBOX_MGMT.QUALITY.CHART.LEVEL_NA',
};

const CSV_SEPARATOR = ';';
// O BOM faz o Excel abrir o arquivo como UTF-8 e preservar os acentos
const CSV_BOM = '﻿';

export const normalizeRating = rating =>
  LEVEL_LABEL_KEYS[rating] ? rating : 'na';

export const formatIsoDate = isoDate => {
  const [year, month, day] = isoDate.split('-');
  return `${day}/${month}/${year}`;
};

const BRASILIA_FORMATTER = new Intl.DateTimeFormat('pt-BR', {
  timeZone: 'America/Sao_Paulo',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hourCycle: 'h23',
});

export const formatBrasiliaDateTime = (isoDate, time) => {
  const parts = BRASILIA_FORMATTER.formatToParts(
    new Date(`${isoDate}T${time}Z`)
  ).reduce((acc, part) => ({ ...acc, [part.type]: part.value }), {});
  return `${parts.day}/${parts.month}/${parts.year} ${parts.hour}:${parts.minute}:${parts.second}`;
};

const csvCell = value => {
  const text = String(value);
  return /[";\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

export const buildQualityHistoryCsv = (records, t) => {
  const header = [
    t('INBOX_MGMT.QUALITY.TABLE.DATE'),
    t('INBOX_MGMT.QUALITY.TABLE.TIME'),
    t('INBOX_MGMT.QUALITY.TABLE.BRASILIA_DATETIME'),
    t('INBOX_MGMT.QUALITY.TABLE.QUALITY'),
  ];
  const rows = records.map(record => [
    formatIsoDate(record.date),
    record.time,
    formatBrasiliaDateTime(record.date, record.time),
    t(LEVEL_LABEL_KEYS[normalizeRating(record.rating)]),
  ]);
  const lines = [header, ...rows].map(row =>
    row.map(csvCell).join(CSV_SEPARATOR)
  );
  return `${CSV_BOM}${lines.join('\r\n')}`;
};

export const qualityHistoryFileName = (phoneNumber, now = new Date()) => {
  const phone = String(phoneNumber || '').replace(/\D/g, '');
  const day = String(now.getUTCDate()).padStart(2, '0');
  const month = String(now.getUTCMonth() + 1).padStart(2, '0');
  return `qualidade-numero-${phone}-${day}-${month}-${now.getUTCFullYear()}.csv`;
};
